import type { ReactNode } from "react";

export const GuideStep = ({
  id,
  step,
  title,
  children,
}: {
  id: string;
  step: number;
  title: string;
  children: ReactNode;
}) => (
  <section aria-labelledby={id}>
    <h2 id={id}>
      <span className="mb-1 block text-xs font-semibold tracking-widest text-subtle uppercase">
        Step {step}
      </span>
      {title}
    </h2>
    {children}
  </section>
);
